import { render } from "./PolicyHistoryFab.vue?vue&type=template&id=4727fb7d&scoped=true"
import script from "./PolicyHistoryFab.vue?vue&type=script&lang=js"
export * from "./PolicyHistoryFab.vue?vue&type=script&lang=js"

import "./PolicyHistoryFab.vue?vue&type=style&index=0&id=4727fb7d&scoped=true&lang=css"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4727fb7d"]])

export default __exports__